exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header--1t7ys {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 10px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #C0C0C0;\n}\n\n.hint--3KRb0 {\n  font-size: 14px;\n  font-weight: 400;\n  color: #878787;\n}\n", ""]);

// exports
exports.locals = {
	"header": "header--1t7ys",
	"hint": "hint--3KRb0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/emission/cards/limits/CardLimits/CardLimits.m.scss
// module id = 1398
// module chunks = 0